import React, { FC, useRef, useState } from 'react';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { settlementDataStore } from 'src/store/settlementInfo';
import { addComma } from 'src/utils/common';
import DescLabel from 'src/components/atoms/label/DescLabel';
import TableGrid from 'src/components/atoms/grid/TableGrid';
import { setDeDataStore } from 'src/fetch/data/store';
import { settlementNtsDataStore } from 'src/store/settlementInfo';
import './style.scss';

interface Props {
  data: any;
  confirmEvent: any;
  detailViewEvent: any;
}

const HomeTaxData: FC<Props> = ({ data, confirmEvent, detailViewEvent }) => {
  // const dataSet = {};
  // const setData = data;
  // const totalCount = 1;
  // const bindStateData = setDeDataStore(state => state.bindData);
  // const optionSet: any = gridOption(setData, totalCount, bindStateData);

  const settlementDataInitState = settlementDataStore((state: any) => state.bind);
  const settlementDataParam = settlementDataStore((state: any) => state.param);
  const settlementData = settlementDataStore((state: any) => state.result).data || {};

  // const refundStatus = settlementData.total?.totRefundPaid || 0; // 환급/납부
  // const determinedPaid = settlementData.total?.totDeterminedPaid || 0; // 결정세액
  // const prePaid = settlementData.total?.totPrePaid || 0; // 결정세액

  let refundStatus = 0;
  let refundStatusText = '환급';
  refundStatus = settlementData.total?.totRefundPaid || 0; // 환급/납부
  const determinedPaid = settlementData.total?.totDeterminedPaid || 0; // 결정세액
  const prePaid = settlementData.total?.totPrePaid || 0; // 기납세액
  if (determinedPaid > prePaid) {
    refundStatus = refundStatus * -1;
    refundStatusText = '추가납부';
  }

  const reStatus =
    refundStatus < 0 ? { txt: '추가납부', id: '_minus' } : { txt: '환급', id: '_add' };

  const detailClickEvt = (e: any) => {
    detailViewEvent();
  };
  const confirmEvt = (e: any) => {
    confirmEvent();
  };

  return (
    <div className="_step_e_totalpayment_data">
      <div className="_content">
        <div className="_account_div">
          <div className="_main_account">
            <div className={['_item', reStatus.id].join(' ')}>
              <div className="_label">{reStatus.txt}</div>
              <div className="_cont">
                {/* <span className="_seper">{reStatus.id === '_add' ? '+' : '-'}</span> */}
                {addComma(Math.abs(refundStatus))}
                <em>원</em>
              </div>
            </div>
          </div>
          <div className="_sub_account">
            <div className="_item">
              <div className="_label">결정세액</div>
              <div className="_cont">{addComma(determinedPaid)}</div>
            </div>
            <div className="_item">
              <div className="_label">기납세액</div>
              <div className="_cont">
                <span className="_seper">-</span>
                {addComma(prePaid)}
              </div>
            </div>
          </div>
          <div className="_total_account">
            <div className="_item">
              <div className="_label">차감 징수세액</div>
              <div className="_cont">
                {/* <span className="_seper">{reStatus.id === '_add' ? '+' : '-'}</span> */}
                {addComma(Math.abs(refundStatus))}
              </div>
            </div>
          </div>
          <div className="_account_desc _ft_lb_t1">
            상기 금액은 추정 값 이므로 확정 이후 최종 금액과 차이가 있을 수 있습니다.
          </div>
          <div className="_btn_div">
            <div className="_item">
              <DefaultButton
                text="관리자 저장"
                clickEvent={e => confirmEvt(e)}
                // icon="ri-file-text-line"
                type="type5"
                styleDef={{ height: '36px', fontSize: '14px', width: '250px' }}
              />
            </div>
            <div className="_item">
              <DefaultButton
                text="상세내역 보기"
                clickEvent={e => detailClickEvt(e)}
                icon="ri-file-text-line"
                type="type1"
                styleDef={{ height: '36px', fontSize: '13px', width: '250px', color: '#555' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTaxData;
